module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "quill",
    staticClass: "ui attached segment",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.focusEditor($event)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9a545482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-quill/src/Quill.vue
// module id = 1465
// module chunks = 1